import { ThemeProviderContext } from '@/contexts/ThemeProviderContext';
import { ThemeMode } from '@/types/theme';
import { useContext } from 'react';

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);

  if (context === undefined)
    throw new Error('useTheme must be used within a ThemeProvider');

  return context;
};

export const useThemeMode = (): ThemeMode => {
  const { theme, preferredTheme } = useTheme();

  return theme === 'system' ? preferredTheme : theme;
};
